import routes from "../../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPut} from "../../../../../core/services/common/HttpRequestBuilder"


const businessDriverList = (org_uid) => {
    let query_params ={
        org_uid: org_uid
    }

    let result = HttpAuthGet(routes.BUSINESS_DRIVER_LIST, query_params);
    return result;
}

const createBusinessDriver = (payload) => {
    let result = HttpAuthPost(routes.CREATE_BUSINESS_DRIVER, payload);
    return result;
}

const businessViewDriver = (parameters) => {
    let result = HttpAuthGet(routes.BUSINESS_VIEW_DRIVER_LIST, parameters);
    return result;
}

const updateDriverStatus = (parameters) => {
    let result = HttpAuthPut(routes.UPDATE_BUSINESS_DRIVER_STATUS, parameters);
    return result;
}




const AssetService = {
    businessDriverList,
    createBusinessDriver,
    businessViewDriver,
    updateDriverStatus

}

export default AssetService
